/* eslint-disable */
let details = {}

const onFor = (property, message) => {
  if (details[property]) {
    details[property].count
      ? details[property].count += 1
      : details[property].count = 2 // count is only defined if there's more than 1
    if (message) {
      details[property].message = message;
    }
  } else {
    details[property] = {
      status: true,
      message
    }
  }
}

const offFor = function(property) {
  delete details[property];
}

// const offFor = function (property) {
//   if (!details[property]) {
//     return;
//   } else if (!details[property].count || details[property].count === 1) {
//     delete details[property];
//   } else {
//     details[property].count -= 1;
//   }
// }

const toggleFor = function (property, message) {
  if (details[property]) {
    delete details[property];
  } else {
    details[property] = {
      status: true,
      message
    }
  }
}

const clearAll = function () {
  for (const key in details) delete details[key]
}

let fore = details;

export default {
  onFor,
  offFor,
  toggleFor,
  clearAll,
  fore,
  details
}



// WEBPACK FOOTER //
// ./src/plugins/factory/SharedService.js